import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export class MessageDialogData {
  public Title: string;
  public Content: string;

  constructor() {
  }
}

@Component({
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss']
  })
  export class MessageDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: MessageDialogData) {}
  }
